import React, { useState, useEffect,useCallback  } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { AddCircle as AddCircleIcon, Delete as DeleteIcon } from '@mui/icons-material';

function ItemListConfigTable({ tableData, setTableData, errors, touched, tableKey, otherTableData }) {
  const initialSelectOptions = ['String', 'Long', 'Double','MultipartFile'];
  const [allSecondOptions, setAllSecondOptions] = useState({
    'String': ['strAttribute1', 'strAttribute2', 'strAttribute3','strAttribute4', 'strAttribute5', 'strAttribute6','strAttribute7', 'strAttribute8', 'strAttribute9','strAttribute10', 'strAttribute11', 'strAttribute12'],
    'Long': ['longWrapperAttribute1', 'longWrapperAttribute2', 'longWrapperAttribute3','longWrapperAttribute4', 'longWrapperAttribute5', 'longWrapperAttribute6','longWrapperAttribute7', 'longWrapperAttribute8', 'longWrapperAttribute9'],
    'Double': ['doubleWrapperAttribute1', 'doubleWrapperAttribute2', 'doubleWrapperAttribute3','doubleWrapperAttribute4', 'doubleWrapperAttribute5', 'doubleWrapperAttribute6','doubleWrapperAttribute7', 'doubleWrapperAttribute8', 'doubleWrapperAttribute9',
      'doubleWrapperAttribute10','doubleWrapperAttribute11', 'doubleWrapperAttribute12', 'doubleWrapperAttribute13','doubleWrapperAttribute14', 'doubleWrapperAttribute15', 'doubleWrapperAttribute16','doubleWrapperAttribute17', 'doubleWrapperAttribute18', 'doubleWrapperAttribute19'
    ],
    'MultipartFile': ['fileAttribute1', 'fileAttribute2', 'fileAttribute3'],
  });

  const handleAddRow = () => {
    setTableData(tableKey, [...tableData, { placeHolderText: '', description: '', dataType: 'String', correspondingTableColumnName: '', file: null }]);
  };

  const handleRemoveRow = (index) => {
    const newTableData = [...tableData];
    newTableData.splice(index, 1);
    setTableData(tableKey, newTableData);
  };

  const handleChange = (index, event) => {
    const { name, value } = event.target;
    const newTableData = [...tableData];
    newTableData[index][name] = value;
    setTableData(tableKey, newTableData);
  };

  const handleSelectChange = (index, event) => {
    const { value } = event.target;
    const newTableData = [...tableData];
    newTableData[index].dataType = value;
    newTableData[index].correspondingTableColumnName = '';  // Reset second select
    newTableData[index].file = null;
    setTableData(tableKey, newTableData);
  };

  const handleSecondSelectChange = (index, event) => {
    const { value } = event.target;
    const newTableData = [...tableData];
    newTableData[index].correspondingTableColumnName = value;
    setTableData(tableKey, newTableData);
  };

  const handleFileChange = (index, event) => {
    const file = event.target.files[0];
    const newTableData = [...tableData];
    newTableData[index].file = file;
    setTableData(tableKey, newTableData);
  };

  // Function to get available options for the second select (excluding already selected)
  const getAvailableSecondOptions = useCallback((index) => {
    const firstChoice = tableData[index].dataType;
    const allOptions = allSecondOptions[firstChoice] || [];

    // Get currently selected options in the current table
    const selectedOptions = tableData.map((row, i) => (i !== index ? row.correspondingTableColumnName : null)).filter(Boolean);

    // Also, get selected options from the other table
    const otherSelectedOptions = otherTableData ? otherTableData.map(row => row.correspondingTableColumnName).filter(Boolean) : [];

    // Combine selected options from both tables
    //commented this line to exclude validation of selected column in another table
    //const allSelectedOptions = [...selectedOptions, ...otherSelectedOptions]; 
    const allSelectedOptions = [...selectedOptions];

    return allOptions.filter(option => !allSelectedOptions.includes(option));
}, [tableData, otherTableData, allSecondOptions]);


  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Place Holder Text</TableCell>
            <TableCell>Select Data Type</TableCell>
            <TableCell>Select corresponding table column name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {tableData.map((row, index) => (
            <TableRow key={index}>
              <TableCell>
                <TextField
                  name="placeHolderText"
                  value={row.placeHolderText}
                  onChange={(event) => handleChange(index, event)}
                  error={touched && touched[index] && touched[index].placeHolderText && errors && errors[index] && errors[index].placeHolderText ? true : false}
                  helperText={touched && touched[index] && touched[index].placeHolderText && errors && errors[index] && errors[index].placeHolderText ? errors[index].placeHolderText : null}
                />
              </TableCell>
             
              <TableCell>
                <FormControl fullWidth>
                  <InputLabel id={`select-label-${index}`}>Data Type</InputLabel>
                  <Select
                    labelId={`select-label-${index}`}
                    name="dataType"
                    value={row.dataType}
                    onChange={(event) => handleSelectChange(index, event)}
                  >
                    {initialSelectOptions.map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              <TableCell>
                <FormControl fullWidth>
                  <InputLabel id={`second-select-label-${index}`}>Second Choice</InputLabel>
                  <Select
                    labelId={`second-select-label-${index}`}
                    name="correspondingTableColumnName"
                    value={row.correspondingTableColumnName}
                    onChange={(event) => handleSecondSelectChange(index, event)}
                  >
                    {getAvailableSecondOptions(index).map((option) => (
                      <MenuItem key={option} value={option}>{option}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </TableCell>
              {/* <TableCell>
                {row.dataType === 'MultipartFile' && (
                  <input
                    type="file"
                    onChange={(event) => handleFileChange(index, event)}
                  />
                )}
              </TableCell> */}
              {/* <TableCell>
                <TextField
                  name="columnHeader"
                  value={row.columnHeader}
                  onChange={(event) => handleChange(index, event)}
                  error={touched && touched[index] && touched[index].columnHeader && errors && errors[index] && errors[index].columnHeader ? true : false}
                  helperText={touched && touched[index] && touched[index].columnHeader && errors && errors[index] && errors[index].columnHeader ? errors[index].columnHeader : null}
                />
                </TableCell> */}
              <TableCell>
                <TextField
                  name="description"
                  value={row.description}
                  onChange={(event) => handleChange(index, event)}
                  error={touched && touched[index] && touched[index].description && errors && errors[index] && errors[index].description ? true : false}
                  helperText={touched && touched[index] && touched[index].description && errors && errors[index] && errors[index].description ? errors[index].description : null}
                />
              </TableCell>
              <TableCell>
                <IconButton onClick={() => handleRemoveRow(index)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
          <TableRow>
            <TableCell colSpan={6}>
              <IconButton onClick={handleAddRow}>
                <AddCircleIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default ItemListConfigTable;